<script>
  import { onDestroy, tick } from "svelte";
  import { Subscriber, collections, asteroid } from "@/meteor.js";
  import { fade, fly } from "svelte/transition";
  import { debounce } from "@/utils.js";
  import filterIcon from "@iconscout/unicons/svg/filter.svg";
  export let url,
    route,
    send,
    receive,
    fulltext,
    queryOptions = { limit: 50 },
    queryFields = [],
    collectionName,
    unitName,
    unitNamePlural;

  let showQueryOptions = false;

  const collection = collections[collectionName];

  let renderingNavigation = true;
  setTimeout(() => {
    renderingNavigation = false;
  }, 1000);

  function activeQuery() {
    const options = Object.assign({}, queryOptions);
    const query = {};

    if (fulltext) {
      query.$text = { $search: fulltext };
      options.fields = { score: { $meta: "textScore" } };
      options.sort = { score: { $meta: "textScore" } };
    }

    queryFields.forEach(field => {
      query[field.key] = field.value;
    });

    options.limit = Math.min(500, options.limit);

    console.log("q", query);

    return { query: query, options: options };
  }

  $: console.log(queryFields);

  const subscribe = Subscriber(collectionName);
  $subscribe;

  const debouncer = debounce(function() {
    const { query, options } = activeQuery();
    subscribe.setQuery(collectionName, query, options);
  }, 300);

  $: debouncer() && fulltext && queryOptions && queryFields;

  (async () => {
    await tick();
    document.getElementById("search").focus();
  })();

  async function handleInsert() {
    const id = await asteroid.call(`${collectionName}.insert`, {});
    if (id) history.pushState({}, null, url(`/${collectionName}/${id}`));
  }
</script>

<style>
  .nav-form ul li div {
    @apply text-gray-600;
  }
  .nav-form ul li input {
    /* @apply text-2xl; */
  }
  .nav-form ul li {
    @apply flex flex-wrap content-center;
  }
</style>

<div class="absolute inset-0 overflow-auto">

  <!-- MAIN  -->
  <main class="absolute inset-0 mt-16 overflow-hidden" out:fly={{ y: 500 }}>
    {#if !renderingNavigation && $collection && Object.keys($collection).length}
      <div class="absolute inset-0 p-8 overflow-auto" in:fly={{ y: -500 }}>
        {#if collection}
          <slot collection={$collection}>
            <!-- optional fallback -->
          </slot>
        {/if}
      </div>
    {/if}

    <button
      class="absolute bottom-0 right-0 mr-12 mb-4 btn solid green"
      on:click={handleInsert}>
      Tilføj {unitName}
    </button>
    <slot name="slot" />
  </main>

  <!-- TOP NAV -->
  <nav class="relative nav-form h-16" out:fly={{ y: -100 }}>
    <div class="absolute inset-0 shadow bg-white" in:fade={{ delay: 500 }} />
    <ul class="relative flex content-center sm:px-8 px-3 py-2 h-full">
      <li class="w-1/3" />
      <li class="w-1/3 justify-center flex flex-col">
        <div>
          <input
            type="text"
            id="search"
            bind:value={fulltext}
            in:receive={{ key: 'searchBox' }}
            class="focus text-center md:text-2xl text-lg w-full"
            placeholder="søg" />
        </div>
        {#if queryFields.length}
          <button
            class="btn sm gray"
            on:click={() => (showQueryOptions = true)}>
            <span class="icon text-gray-500">
              {@html filterIcon}
            </span>

          </button>
          {#if showQueryOptions}
            <div>
              <div
                class="fixed inset-0"
                on:click={() => (showQueryOptions = false)} />
              <div class="absolute bg-white shadow p-3 border border-gray-100">
                {#each queryFields as field}
                  <label for={field.key}>{field.name}</label>
                  {#if field.type === 'dropdown'}
                    <select id={field.key} bind:value={field.value}>
                      {#each field.options as option}
                        <option value={option.value}>{option.name}</option>
                      {/each}
                    </select>
                  {/if}

                  <!-- {JSON.stringify(field)} -->
                {/each}
              </div>
            </div>
          {/if}
        {/if}
      </li>
      <li class="w-1/3 justify-end">
        <div>
          <span class="hidden sm:inline-block">Antal pr side</span>
          <input
            type="number"
            bind:value={queryOptions.limit}
            class="outline-none shadow-inner text-center rounded bg-gray-200
            w-16"
            placeholder="antal pr side" />
        </div>
      </li>
    </ul>
  </nav>
</div>
